export const baseVideoAsset = {
  videoUrl: "",
  title: "",
  description: "",
  privacyStatus: "unlisted" as const,
};
